module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-modal"
  }, [_c('div', {
    staticClass: "logout-flex"
  }, [_c('div', {
    staticClass: "logout-content"
  }, [_c('h2', {
    staticClass: "logout-heading"
  }, [_vm._v("\n                Join the world's creators & music lovers.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "btns-wrapper mt-4"
  }, [_c('v-btn', {
    staticClass: "signup",
    attrs: {
      "round": "",
      "to": "/signup"
    }
  }, [_vm._v("Signup")]), _vm._v(" "), _c('v-btn', {
    staticClass: "login ml-3",
    attrs: {
      "round": "",
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1)]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/banner.gif"),
      "width": "100%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d1d024b","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LogoutModal/index.vue
// module id = 1668
// module chunks = 180